"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _comparisonActions = require("../../store/comparison/comparisonActions");
var _comparisonSelectors = require("../../store/comparison/comparisonSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _upsellActions = require("../../store/upsell/upsellActions");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var useComparison = function useComparison() {
  var _useSelector = (0, _reactRedux.useSelector)(_widgetSelectors.selectComparisonSettings),
    showComparisonForDevices = _useSelector.showComparisonForDevices;
  var dispatch = (0, _reactRedux.useDispatch)();
  var products = (0, _reactRedux.useSelector)(_comparisonSelectors.selectComparableProductsList);
  var displayedProducts = (0, _reactRedux.useSelector)(_comparisonSelectors.selectDisplayedProducts);
  var showDevices = (0, _reactRedux.useSelector)(_comparisonSelectors.selectShowDevices);
  var showPlans = (0, _reactRedux.useSelector)(_comparisonSelectors.selectShowPlans);
  var onProductSelect = function onProductSelect(productId) {
    if (products[productId].productType === 'handset') {
      dispatch((0, _recommendationActions.updateSelectedHandset)(productId));
    } else if (products[productId].productType === 'plan') {
      dispatch((0, _recommendationActions.updateSelectedPlan)(productId));
    } else {
      dispatch((0, _recommendationActions.updateSelectedBroadband)(productId));
    }
    dispatch((0, _upsellActions.goBackToRecommendation)());
  };
  //Extrapolate the category of products to show based on journey.

  var notSelectedProducts = Object.values(products).filter(function (product) {
    return !displayedProducts.includes(product.productId);
  });
  var updateCurrentSelectedProducts = function updateCurrentSelectedProducts(previousId, newId) {
    dispatch((0, _comparisonActions.updateDisplayedProduct)(previousId, newId));
  };
  return {
    showComparisonDevices: showComparisonForDevices,
    products: products,
    displayedProducts: displayedProducts,
    updateCurrentSelectedProducts: updateCurrentSelectedProducts,
    showDevices: showDevices,
    showPlans: showPlans,
    onProductSelect: onProductSelect,
    notSelectedProducts: notSelectedProducts
  };
};
var _default = useComparison;
exports.default = _default;